import React from 'react'
import CommonHeader from '../../../navbars/CommonHeader';
import BrandLogo from '../../../navbars/BrandLogo';

// Public "default" video links are watched without logging in.
const PUBLIC_URL_TYPES = ["default", "fdefaultvideo"];

// Where the back arrow goes: back to the chapter/topic/video list the video
// was opened from.
function backTarget({ getChapterId = {}, urltype, mname }) {
    if (getChapterId.type != "iv") {
        const chapter = getChapterId.getChapterId || {};
        const pagetype = getChapterId.ComponentParams && getChapterId.ComponentParams.pagetype;
        if (pagetype == "chlistpath") {
            return { pathname: "/student/subject/start-watching", state: { otid: "0", ocid: "0", subjectid: chapter.subjectid } };
        }
        if (pagetype == "topiclistpath") {
            return { pathname: "/student/subject/start-watching", state: { otid: "0", ocid: chapter.ocid, subjectid: chapter.subjectid } };
        }
        return {
            pathname: "/student/subject/start-learning",
            state: { ocid: chapter.ocid, otid: chapter.otid, subjectid: chapter.subjectid, defaultActiveKey: "third" }
        };
    }
    if (urltype == "default") return "/student/default-videos";
    if (urltype == "fdefaultvideo") return "/student/default-featured-videos";
    if (mname == "feartured") return "/student/featuredvideos";
    if (urltype == "categoryWiseVideo" || urltype == "notification") return true;
    return "/student/videos";
}

/**
 * Single-video page header: the shared CommonHeader (its own colour) with the
 * brand logo. Public video links get no logo and no user menu.
 */
function VideoNavbar(props) {
    const isPublic = PUBLIC_URL_TYPES.includes(props.urltype);
    return (
        <CommonHeader
            color="auto"
            tone="light"
            back={backTarget(props)}
            backLabel=""
            showUserMenu={!isPublic}
            left={isPublic ? null : (
                <div className="my-2 my-md-0 mr-md-5 mx-auto">
                    <BrandLogo fill="#ffffff" width="159.501" />
                </div>
            )}
        />
    );
}

export default VideoNavbar;
